export default __webpack_public_path__ + "static/media/powered.bb638dd5.png";